const ALL_DRAGON_LANGUAGES = ['ca', 'da', 'de', 'en', 'es', 'fi', 'fr', 'hu', 'it', 'nl', 'no', 'pt', 'sl', 'sv'] as const;
type DRAGON_LANGUAGE_TUPLE = typeof ALL_DRAGON_LANGUAGES;
export type DRAGON_LANGUAGE = DRAGON_LANGUAGE_TUPLE[number];

export const DEFAULT_DRAGON_LANGUAGE = 'en' as DRAGON_LANGUAGE;

export const IsDragonLanguage = (dragonLanguageString: string): dragonLanguageString is DRAGON_LANGUAGE => {
    return ALL_DRAGON_LANGUAGES.includes(dragonLanguageString as DRAGON_LANGUAGE);
};

export const TryParseDragonLanguage = (dragonLanguageString: string): DRAGON_LANGUAGE | undefined => {
    const re = /^[a-z]{2}-.*$/;
    const isLocale = re.test(dragonLanguageString);

    const dragonString = isLocale ? dragonLanguageString.substring(0, 1) : dragonLanguageString;
    if (IsDragonLanguage(dragonString)) {
        return dragonString;
    }
};

export const GetValidDragonIETFLangTags = (): string[] => {
    return Array.from(GetDragonLanguageOptions().keys());
};

export const GetDragonLanguageOptions = (): Map<DRAGON_LANGUAGE, string> => {
    return new Map([
        ['ca', 'Català'],
        ['da', 'Dansk'],
        ['de', 'Deutsch'],
        ['en', 'English'],
        ['es', 'Espagnol'],
        ['fi', 'Suomi'],
        ['fr', 'Français'],
        ['hu', 'Magyar Nyelv'],
        ['it', 'Italiano'],
        ['nl', 'Nederlands'],
        ['no', 'Norsk'],
        ['pt', 'Português'],
        ['sl', 'Slovenščina'],
        ['sv', 'Svenska'],
    ]);
};
